import React from 'react';
import './App.css';
import Router from './Router';
import { BrowserRouter } from 'react-router-dom'

function App(){
  return (
    <BrowserRouter>
      <Router />
    </BrowserRouter>
  )
}

export default App

